export function formatDistance(distance: number): string {
  const km = Math.round(distance / 1000)
  return `${km} km`
}
